import { render, staticRenderFns } from "./manage-tags-table.vue?vue&type=template&id=5259c5af&scoped=true&"
import script from "./manage-tags-table.vue?vue&type=script&lang=js&"
export * from "./manage-tags-table.vue?vue&type=script&lang=js&"
import style0 from "./manage-tags-table.vue?vue&type=style&index=0&id=5259c5af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5259c5af",
  null
  
)

component.options.__file = "manage-tags-table.vue"
export default component.exports